/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProviderComponent } from './providerComponent';


export interface ProviderComponentInventory { 
    /**
     * Reporting agent identifier
     */
    agent_id: string;
    /**
     * List of component
     */
    components: Array<ProviderComponent>;
    /**
     * Whether complete detail of components and peer components has been provided or only for certain components
     */
    is_partial_update?: boolean;
    /**
     * Job identifier. This will contains the job id when payload is requested from provider.
     */
    job_id?: string;
    /**
     * List of peer component
     */
    peer_components?: Array<ProviderComponent>;
    /**
     * Report time for inventory information
     */
    report_time: Date;
}

